// extracted by mini-css-extract-plugin
module.exports = {"viewAllButton":"vsjcltTq","viewAllButtonWrapper":"vMMHULk2","borderPath":"cfhBJfPJ","backgroundPath":"a4uEmOhG"};